
<!--start header-->

<header>
    <div class="not-found">
         <div class="route">
                <h1>
                    404
                    <p>SORRY PAGE NOR FOUND!</p>
                 </h1>
                
                 <button class="btn btn-outline-info" (click) = change() >Back to Home</button>
         </div>
    </div>
</header>

<!--end header-->

